/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CompanyListView } from '../model';
// @ts-ignore
import { CompanyReadView } from '../model';
// @ts-ignore
import { ErrorView } from '../model';
// @ts-ignore
import { SearchReadView } from '../model';
/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary List companies
     * @param {number} [limit] Maximum amount of items per page
     * @param {number} [offset] Page offset
     * @param {number} [organisationId] Filter by organisation
     * @param {string} [search] Filter by search term
     * @param {number} [portfolioId] Filter by portfolio
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companyResourceList: async (
      limit?: number,
      offset?: number,
      organisationId?: number,
      search?: string,
      portfolioId?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/companies`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication default required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search;
      }

      if (portfolioId !== undefined) {
        localVarQueryParameter['portfolioId'] = portfolioId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Read a company
     * @param {number} id Company ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companyResourceRead: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('companyResourceRead', 'id', id);
      const localVarPath = `/v1/companies/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication default required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Search for things
     * @param {string} query Search term
     * @param {number} limit Maximum amount of items per kind
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchResourceList: async (
      query: string,
      limit: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'query' is not null or undefined
      assertParamExists('searchResourceList', 'query', query);
      // verify required parameter 'limit' is not null or undefined
      assertParamExists('searchResourceList', 'limit', limit);
      const localVarPath = `/v1/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication default required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      if (query !== undefined) {
        localVarQueryParameter['query'] = query;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary List companies
     * @param {number} [limit] Maximum amount of items per page
     * @param {number} [offset] Page offset
     * @param {number} [organisationId] Filter by organisation
     * @param {string} [search] Filter by search term
     * @param {number} [portfolioId] Filter by portfolio
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async companyResourceList(
      limit?: number,
      offset?: number,
      organisationId?: number,
      search?: string,
      portfolioId?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListView>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.companyResourceList(
        limit,
        offset,
        organisationId,
        search,
        portfolioId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Read a company
     * @param {number} id Company ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async companyResourceRead(
      id: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyReadView>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.companyResourceRead(id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Search for things
     * @param {string} query Search term
     * @param {number} limit Maximum amount of items per kind
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchResourceList(
      query: string,
      limit: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchReadView>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchResourceList(query, limit, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = CompanyApiFp(configuration);
  return {
    /**
     *
     * @summary List companies
     * @param {number} [limit] Maximum amount of items per page
     * @param {number} [offset] Page offset
     * @param {number} [organisationId] Filter by organisation
     * @param {string} [search] Filter by search term
     * @param {number} [portfolioId] Filter by portfolio
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companyResourceList(
      limit?: number,
      offset?: number,
      organisationId?: number,
      search?: string,
      portfolioId?: number,
      options?: any
    ): AxiosPromise<CompanyListView> {
      return localVarFp
        .companyResourceList(limit, offset, organisationId, search, portfolioId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Read a company
     * @param {number} id Company ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companyResourceRead(id: number, options?: any): AxiosPromise<CompanyReadView> {
      return localVarFp.companyResourceRead(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search for things
     * @param {string} query Search term
     * @param {number} limit Maximum amount of items per kind
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchResourceList(query: string, limit: number, options?: any): AxiosPromise<SearchReadView> {
      return localVarFp.searchResourceList(query, limit, options).then((request) => request(axios, basePath));
    }
  };
};

/**
 * Request parameters for companyResourceList operation in CompanyApi.
 * @export
 * @interface CompanyApiCompanyResourceListRequest
 */
export interface CompanyApiCompanyResourceListRequest {
  /**
   * Maximum amount of items per page
   * @type {number}
   * @memberof CompanyApiCompanyResourceList
   */
  readonly limit?: number;

  /**
   * Page offset
   * @type {number}
   * @memberof CompanyApiCompanyResourceList
   */
  readonly offset?: number;

  /**
   * Filter by organisation
   * @type {number}
   * @memberof CompanyApiCompanyResourceList
   */
  readonly organisationId?: number;

  /**
   * Filter by search term
   * @type {string}
   * @memberof CompanyApiCompanyResourceList
   */
  readonly search?: string;

  /**
   * Filter by portfolio
   * @type {number}
   * @memberof CompanyApiCompanyResourceList
   */
  readonly portfolioId?: number;
}

/**
 * Request parameters for companyResourceRead operation in CompanyApi.
 * @export
 * @interface CompanyApiCompanyResourceReadRequest
 */
export interface CompanyApiCompanyResourceReadRequest {
  /**
   * Company ID
   * @type {number}
   * @memberof CompanyApiCompanyResourceRead
   */
  readonly id: number;
}

/**
 * Request parameters for searchResourceList operation in CompanyApi.
 * @export
 * @interface CompanyApiSearchResourceListRequest
 */
export interface CompanyApiSearchResourceListRequest {
  /**
   * Search term
   * @type {string}
   * @memberof CompanyApiSearchResourceList
   */
  readonly query: string;

  /**
   * Maximum amount of items per kind
   * @type {number}
   * @memberof CompanyApiSearchResourceList
   */
  readonly limit: number;
}

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
  /**
   *
   * @summary List companies
   * @param {CompanyApiCompanyResourceListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public companyResourceList(
    requestParameters: CompanyApiCompanyResourceListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CompanyApiFp(this.configuration)
      .companyResourceList(
        requestParameters.limit,
        requestParameters.offset,
        requestParameters.organisationId,
        requestParameters.search,
        requestParameters.portfolioId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Read a company
   * @param {CompanyApiCompanyResourceReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public companyResourceRead(requestParameters: CompanyApiCompanyResourceReadRequest, options?: AxiosRequestConfig) {
    return CompanyApiFp(this.configuration)
      .companyResourceRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search for things
   * @param {CompanyApiSearchResourceListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public searchResourceList(requestParameters: CompanyApiSearchResourceListRequest, options?: AxiosRequestConfig) {
    return CompanyApiFp(this.configuration)
      .searchResourceList(requestParameters.query, requestParameters.limit, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
